<ng-container *ngIf="vm$ | async as vm">
	<div>
		<app-container
			type="dark"
			title="Options"
			class="mt-5"
			*ngIf="vm.showPurchaseOptions"
			data-intercom-target="global-profile-purchase-options"
		>
			<app-checkbox
				type="clear"
				*ngIf="!vm.isGuarantor"
				[ngModel]="vm.isPurchaser"
				[disabled]="!vm.showOfferor"
				(ngModelChange)="isPurchaserChecked($event)"
				class="mt-2"
				[testHook]="testHooks.IsPurchaserCheckCheckbox"
				>Purchaser</app-checkbox
			>
			<app-checkbox
				type="clear"
				[ngModel]="vm.showOfferor"
				[disabled]="!vm.isPurchaser"
				(ngModelChange)="offerorChecked($event)"
				class="mt-4"
				[testHook]="testHooks.OfferorCheckCheckbox"
				>Offeror</app-checkbox
			>
			<div class="mt-2" *ngIf="vm.showOfferor" [@openClose]>
				<app-input
					label="Name of offeror"
					class="flex-1"
					[required]="true"
					[ngModel]="vm._client?.offeror"
					(debounce)="setOfferor($event)"
					[testHook]="testHooks.NameOfOfferor"
				></app-input>
			</div>
			<app-checkbox
				class="mt-4"
				type="clear"
				*ngIf="vm._client?.type === clientTypes.PERSON && !vm.isGuarantor"
				[ngModel]="vm._client?.firstTimeHomeBuyer"
				(ngModelChange)="setFirstTimeHomeBuyer($event)"
				[testHook]="testHooks.SetFirstTimeHomeBuyerCheckbox"
				>Set as first time homebuyer</app-checkbox
			>
		</app-container>

		<ui-section
			*ngIf="vm._client?.type === clientTypes.PERSON"
			class="mt-5"
			title="FLA Selection"
			[testHook]="testHooks.FlaSelectionSection"
		>
			<div section-content class="flex flex-col">
				<app-dropdown
					label="Spousal status"
					dropdownClasses="max-w-none"
					class="mt-3"
					[itemGroups]="[
						{ items: vm.spousalGroupItems1 },
						{
							title: 'Spouse to outside party',
							items: vm.spousalGroupItems2,
						},
					]"
					[ngModel]="vm.selectedSpouseText"
					(onSelect)="changeFLA($event)"
					[testHook]="testHooks.SpousalStatusDropdown"
				>
				</app-dropdown>

				<app-input
					label="Instrument number"
					[@openClose]
					*ngIf="
						vm.selectedSpouseStatus === spousalStatuses.COURT_AUTH_TRANSACTION
					"
					[ngModel]="vm._client?.fla?.instrumentNumber"
					(debounce)="setInstrumentNumber($event)"
					[testHook]="testHooks.InstrumentNumber"
				></app-input>

				<div
					*ngIf="vm.selectedSpouseStatus === spousalStatuses.CONSENTING"
					[@openClose]
				>
					<app-container
						*ngIf="vm._client?.flaClient"
						class="flex mt-5"
						[@openClose]
					>
						<atomic-party-client-card
							[client]="vm._client?.flaClient"
							[kebabOptions]="spouseKebabOptions"
							(onKebabSelect)="onSpouseKebabSelect($event)"
							[pills]="['Consenting spouse']"
							[testHook]="testHooks.PartyClientCard"
						></atomic-party-client-card>
					</app-container>

					<div
						*ngIf="!vm._client?.flaClient && associations.spousal.length === 0"
					>
						<app-client-search
							[selectedIds]="[vm._client?.id]"
							[searchType]="SearchType.Person"
							label="Search for consenting spouse"
							(clientSelected)="onClientSelected($event)"
							(add)="showCreateNewClient($event)"
							class="mt-3"
						></app-client-search>
					</div>
				</div>
			</div>
		</ui-section>
	</div>
</ng-container>
